import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const SiswaList = ({ token }) => {
  const [siswa, setSiswa] = useState([]);
  const [kelasList, setKelasList] = useState([]); 
  const [loading, setLoading] = useState(true);
  
  // FILTER STATES
  const [keyword, setKeyword] = useState('');
  const [selectedKelas, setSelectedKelas] = useState('');
  
  // MODAL STATES
  const [selectedSiswa, setSelectedSiswa] = useState(null);
  const [stats, setStats] = useState(null);
  const [poinHistory, setPoinHistory] = useState([]);

  // STATE BARU UNTUK BULK DELETE
  const [selectedIds, setSelectedIds] = useState([]);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, [token]);

  // EFEK: Cek apakah ada kiriman filter dari halaman Kelas
  useEffect(() => {
      if (location.state && location.state.filterKelas) {
          setSelectedKelas(location.state.filterKelas);
          window.history.replaceState({}, document.title);
      }
  }, [location]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const resSiswa = await axios.get('https://sijapan.sman10fajarharapan.sch.id/api/siswa', { headers: { Authorization: `Bearer ${token}` } });
      setSiswa(resSiswa.data);
      const resKelas = await axios.get('https://sijapan.sman10fajarharapan.sch.id/api/kelas', { headers: { Authorization: `Bearer ${token}` } });
      setKelasList(resKelas.data);
    } catch (err) { console.error(err); }
    setLoading(false);
  };

  // Fungsi Pilih / Lepas semua checkbox sekaligus
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allIds = filteredSiswa.map(s => s.id);
      setSelectedIds(allIds);
    } else {
      setSelectedIds([]);
    }
  };

  // Fungsi Pilih / Lepas satu checkbox siswa
  const handleSelectRow = (id) => {
    if (selectedIds.includes(id)) {
      setSelectedIds(selectedIds.filter(item => item !== id));
    } else {
      setSelectedIds([...selectedIds, id]);
    }
  };

  // Fungsi Hapus Massal
  const handleBulkDelete = async () => {
    const result = await Swal.fire({
        title: `Yakin hapus ${selectedIds.length} siswa terpilih?`,
        text: "Semua data yang dipilih tidak bisa dikembalikan!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Ya, Hapus Semua!'
    });

    if (result.isConfirmed) {
      try {
        setLoading(true);
        await axios.post('https://sijapan.sman10fajarharapan.sch.id/api/siswa/hapus-massal', { ids: selectedIds }, { headers: { Authorization: `Bearer ${token}` } });
        
        Swal.fire('Terhapus!', 'Siswa terpilih telah berhasil dihapus.', 'success');
        setSelectedIds([]);
        fetchData();
      } catch (err) { 
        Swal.fire('Gagal', 'Gagal menghapus data massal.', 'error'); 
        setLoading(false);
      }
    }
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
        title: 'Yakin hapus siswa ini?',
        text: "Data yang dihapus tidak bisa dikembalikan!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Ya, Hapus!'
    });

    if (result.isConfirmed) {
      try {
        await axios.delete(`https://sijapan.sman10fajarharapan.sch.id/api/siswa/${id}`, { headers: { Authorization: `Bearer ${token}` } });
        const newSiswa = siswa.filter(s => s.id !== id);
        setSiswa(newSiswa);
        // Reset check list jika data yang dihapus sedang di-ceklis
        setSelectedIds(selectedIds.filter(item => item !== id));
        Swal.fire('Terhapus!', 'Data siswa telah dihapus.', 'success');
      } catch (err) { Swal.fire('Gagal', 'Gagal menghapus data.', 'error'); }
    }
  };

  const formatTanggal = (isoString) => {
    if (!isoString || isoString === '0000-00-00') return '-';
    const date = new Date(isoString);
    if (isNaN(date.getTime())) return isoString;
    return date.toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' });
  };

  const handleDetail = async (s) => {
    setSelectedSiswa(s);
    setStats(null);
    setPoinHistory([]);
    try {
        const resAbsen = await axios.get(`https://sijapan.sman10fajarharapan.sch.id/api/absensi?siswa_id=${s.id}`, { headers: { Authorization: `Bearer ${token}` } });
        let h=0, sk=0, i=0, a=0;
        resAbsen.data.forEach(d => {
            if(d.status==='hadir') h++; else if(d.status==='sakit') sk++; else if(d.status==='izin') i++; else if(d.status==='alfa') a++;
        });
        setStats({ h, sk, i, a });
        const resPoin = await axios.get(`https://sijapan.sman10fajarharapan.sch.id/api/poin/${s.id}`, { headers: { Authorization: `Bearer ${token}` } });
        setPoinHistory(resPoin.data);
    } catch (err) { }
  };

  const closeModal = () => { setSelectedSiswa(null); };

  // --- REFACTOR FIXED: IMPORT EXCEL LEWAT NGINX PROXY ---
  const handleImport = async () => {
    const result = await Swal.fire({
        title: 'Import Data Siswa',
        html: `<p style="font-size:13px; color:#64748b">Format Excel (.xlsx):<br/><b>NIS, NAMA, KELAS, TGL_LAHIR, TEMPAT_LAHIR, JK, AGAMA, ALAMAT, HP_ORTU</b></p>`,
        input: 'file',
        inputAttributes: {
            'accept': '.xlsx, .xls',
            'aria-label': 'Upload file data siswa Excel'
        },
        showCancelButton: true,
        confirmButtonText: 'Upload',
        confirmButtonColor: '#10b981',
        cancelButtonText: 'Batal'
    });

    if (result.isConfirmed && result.value) {
        const file = result.value; 
        const formData = new FormData(); 
        formData.append('file', file);

        try {
            setLoading(true);
            
            // Mengubah endpoint ke jalur produksi Nginx tanpa port 10000
            const res = await axios.post('https://sijapan.sman10fajarharapan.sch.id/api/import-siswa', formData, { 
                headers: { 
                    Authorization: `Bearer ${token}`, 
                    'Content-Type': 'multipart/form-data' 
                } 
            });

            Swal.fire({
                title: 'Sukses',
                text: `Berhasil import ${res.data.sukses} siswa dari total ${res.data.total} data.`,
                icon: 'success',
                confirmButtonColor: '#4361ee'
            });
            fetchData();
        } catch (err) { 
            console.error(err);
            const errMessage = err.response?.data?.message || 'Gagal melakukan import data siswa.';
            Swal.fire('Gagal', errMessage, 'error'); 
        } finally {
            setLoading(false);
        }
    }
  };

  const filteredSiswa = siswa.filter(s => {
    const matchKeyword = s.nama.toLowerCase().includes(keyword.toLowerCase()) || s.nis.includes(keyword);
    const matchKelas = selectedKelas ? s.kelas === selectedKelas : true;
    return matchKeyword && matchKelas;
  });

  return (
    <div style={{ paddingBottom: '50px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <div>
            <h2 style={{ color: '#1e293b', margin: 0 }}>Data Siswa</h2>
            <p style={{ margin: '5px 0 0', color: '#64748b', fontSize: '13px' }}>Klik nama siswa untuk melihat biodata lengkap.</p>
        </div>
        <div style={{ display: 'flex', gap: '10px' }}>
            {selectedIds.length > 0 && (
              <button onClick={handleBulkDelete} style={{ padding: '10px 20px', background: '#ef476f', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}>
                🗑️ Hapus Terpilih ({selectedIds.length})
              </button>
            )}
            <button onClick={handleImport} style={{ padding: '10px 20px', background: '#10b981', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}>📥 Import Excel</button>
            <Link to="/siswa/tambah">
                <button style={{ padding: '10px 20px', background: '#4361ee', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}>+ Tambah Siswa</button>
            </Link>
        </div>
      </div>

      <div style={{ display: 'flex', gap: '15px', marginBottom: '25px' }}>
        {/* Dropdown Kelas */}
        <div style={{ position: 'relative' }}>
            <span style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', fontSize: '16px' }}>🏫</span>
            <select 
                value={selectedKelas} 
                onChange={(e) => setSelectedKelas(e.target.value)} 
                style={{ padding: '12px 15px 12px 40px', borderRadius: '8px', border: '1px solid #94a3b8', minWidth: '220px', cursor:'pointer', fontSize: '14px', fontWeight: '500', color: '#334155', background: 'white', boxShadow: '0 2px 5px rgba(0,0,0,0.05)' }}
            >
                <option value="">-- Semua Kelas --</option>
                {kelasList.map(k => (
                    <option key={k.id} value={k.nama_kelas}>{k.nama_kelas}</option>
                ))}
            </select>
        </div>

        {/* Input Pencarian */}
        <div style={{ flex: 1, position: 'relative' }}>
            <span style={{ position: 'absolute', left: '15px', top: '50%', transform: 'translateY(-50%)', fontSize: '16px', color: '#64748b' }}>🔍</span>
            <input 
                type="text" 
                placeholder="Cari Nama Siswa atau NIS..." 
                value={keyword}
                onChange={e => setKeyword(e.target.value)}
                style={{ width: '100%', padding: '12px 15px 12px 45px', borderRadius: '8px', border: '1px solid #94a3b8', fontSize: '14px', background: 'white', boxShadow: '0 2px 5px rgba(0,0,0,0.05)', boxSizing: 'border-box' }}
            />
        </div>
      </div>

      {loading ? <p style={{textAlign:'center'}}>Memuat data...</p> : (
        <div style={{ background: 'white', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)', overflow: 'hidden', border: '1px solid #e2e8f0' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#f8f9fa', textAlign: 'left', borderBottom:'2px solid #e2e8f0' }}>
                <th style={{ padding: '15px', width: '40px', textAlign: 'center' }}>
                  <input 
                    type="checkbox" 
                    onChange={handleSelectAll} 
                    checked={filteredSiswa.length > 0 && selectedIds.length === filteredSiswa.length}
                    style={{ cursor: 'pointer', transform: 'scale(1.2)' }}
                  />
                </th>
                <th style={{ padding: '15px', width: '50px', color:'#475569' }}>No</th>
                <th style={{ padding: '15px', color:'#475569' }}>NIS</th>
                <th style={{ padding: '15px', color:'#475569' }}>Nama Lengkap</th>
                <th style={{ padding: '15px', color:'#475569' }}>Kelas</th>
                <th style={{ padding: '15px', textAlign: 'center', color:'#475569' }}>Aksi</th>
              </tr>
            </thead>
            <tbody>
              {filteredSiswa.length === 0 ? (
                  <tr><td colSpan="6" style={{padding:'30px', textAlign:'center', color:'#94a3b8', fontStyle:'italic'}}>Data tidak ditemukan.</td></tr>
              ) : (
                  filteredSiswa.map((s, idx) => (
                    <tr key={s.id} style={{ borderBottom: '1px solid #f1f5f9', background: selectedIds.includes(s.id) ? '#fff5f5' : 'transparent' }}>
                      <td style={{ padding: '15px', textAlign: 'center' }}>
                        <input 
                          type="checkbox" 
                          checked={selectedIds.includes(s.id)} 
                          onChange={() => handleSelectRow(s.id)}
                          style={{ cursor: 'pointer', transform: 'scale(1.2)' }}
                        />
                      </td>
                      <td style={{ padding: '15px' }}>{idx + 1}</td>
                      <td style={{ padding: '15px', fontWeight: 'bold', color: '#64748b', fontFamily:'monospace' }}>{s.nis}</td>
                      <td 
                        onClick={() => handleDetail(s)}
                        style={{ padding: '15px', fontWeight: '600', color: '#4361ee', cursor: 'pointer', textDecoration:'underline' }}
                        title="Lihat Detail Biodata"
                      >
                        {s.nama}
                      </td>
                      <td style={{ padding: '15px' }}>
                        <span style={{ background: '#eff6ff', color: '#1d4ed8', padding: '4px 10px', borderRadius: '6px', fontSize: '12px', fontWeight:'bold', border:'1px solid #dbeafe' }}>{s.kelas}</span>
                      </td>
                      <td style={{ padding: '15px', textAlign: 'center' }}>
                        <div style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}>
                            <button 
                                onClick={() => navigate(`/cetak-kartu/${s.id}`)}
                                style={{ padding: '6px 10px', background: '#3b82f6', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize:'14px' }}
                                title="Cetak Kartu Pelajar"
                            >
                                🪪
                            </button>

                            <Link to={`/siswa/edit/${s.id}`}>
                              <button style={{ padding: '6px 12px', background: '#f59e0b', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize:'12px', fontWeight:'bold' }}>Edit</button>
                            </Link>
                            <button onClick={() => handleDelete(s.id)} style={{ padding: '6px 12px', background: '#ef476f', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize:'12px', fontWeight:'bold' }}>Hapus</button>
                        </div>
                      </td>
                    </tr>
                  ))
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* --- MODAL DETAIL SISWA --- */}
      {selectedSiswa && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
            <div style={{ background: 'white', width: '650px', maxWidth:'95%', borderRadius: '15px', overflow: 'hidden', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)' }}>
                <div style={{ background: 'linear-gradient(135deg, #4361ee, #3a0ca3)', padding: '25px 25px', color: 'white', display:'flex', alignItems:'center', gap:'20px' }}>
                    <div style={{ width: '60px', height: '60px', background: 'white', color: '#4361ee', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', fontSize: '28px' }}>
                        {selectedSiswa.nama.charAt(0)}
                    </div>
                    <div style={{ flex: 1 }}>
                        <h2 style={{ margin: 0, fontSize:'22px' }}>{selectedSiswa.nama}</h2>
                        <div style={{ fontSize: '13px', opacity: 0.9, marginTop: '8px', display:'grid', gridTemplateColumns:'1fr 1fr', gap:'5px' }}>
                            <span>📅 Lahir: {formatTanggal(selectedSiswa.tgl_lahir)}</span>
                            <span>🏫 Kelas: <b>{selectedSiswa.kelas}</b></span>
                            <span>🆔 NIS: {selectedSiswa.nis}</span>
                            <span>🌐 NISN: {selectedSiswa.nisn || '-'}</span>
                        </div>
                    </div>
                    <button onClick={closeModal} style={{ background: 'rgba(255,255,255,0.2)', border: 'none', color: 'white', width: '30px', height: '30px', borderRadius: '50%', cursor: 'pointer', fontSize:'16px' }}>✕</button>
                </div>

                <div style={{ padding: '25px', overflowY:'auto', maxHeight:'70vh' }}>
                    <h4 style={{ margin: '0 0 10px', fontSize: '14px', color: '#64748b' }}>📊 Statistik Kehadiran</h4>
                    <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
                        <div style={{ flex: 1, textAlign: 'center', background: '#dcfce7', padding: '10px', borderRadius: '8px', color: '#166534' }}><div style={{ fontSize: '11px', fontWeight:'bold' }}>HADIR</div><div style={{ fontSize: '20px', fontWeight: 'bold' }}>{stats?.h || 0}</div></div>
                        <div style={{ flex: 1, textAlign: 'center', background: '#fef3c7', padding: '10px', borderRadius: '8px', color: '#92400e' }}><div style={{ fontSize: '11px', fontWeight:'bold' }}>SAKIT</div><div style={{ fontSize: '20px', fontWeight: 'bold' }}>{stats?.sk || 0}</div></div>
                        <div style={{ flex: 1, textAlign: 'center', background: '#dbeafe', padding: '10px', borderRadius: '8px', color: '#1e40af' }}><div style={{ fontSize: '11px', fontWeight:'bold' }}>IZIN</div><div style={{ fontSize: '20px', fontWeight: 'bold' }}>{stats?.i || 0}</div></div>
                        <div style={{ flex: 1, textAlign: 'center', background: '#fee2e2', padding: '10px', borderRadius: '8px', color: '#991b1b' }}><div style={{ fontSize: '11px', fontWeight:'bold' }}>ALFA</div><div style={{ fontSize: '20px', fontWeight: 'bold' }}>{stats?.a || 0}</div></div>
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                        <div>
                            <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'10px'}}>
                                <h4 style={{ margin: 0, fontSize: '14px', color: '#64748b' }}>Catatan Poin</h4>
                                <div style={{fontSize:'11px'}}>
                                    <span style={{color:'#b91c1c', marginRight:'10px'}}>Pelanggaran: <b>{poinHistory.filter(p=>p.jenis==='pelanggaran').reduce((a,b)=>a+b.poin,0)}</b></span>
                                    <span style={{color:'#15803d'}}>Prestasi: <b>{poinHistory.filter(p=>p.jenis==='prestasi').reduce((a,b)=>a+b.poin,0)}</b></span>
                                </div>
                            </div>
                            <div style={{ height: '150px', overflowY: 'auto', border: '1px solid #e2e8f0', borderRadius: '8px', padding:'5px' }}>
                                {poinHistory.length === 0 ? <div style={{padding:'10px', textAlign:'center', fontSize:'12px', color:'#ccc'}}>Belum ada data.</div> : 
                                    poinHistory.map((p,idx) => (
                                        <div key={idx} style={{borderBottom:'1px solid #f1f5f9', padding:'8px', fontSize:'12px'}}>
                                            <div style={{fontWeight:'bold', color: p.jenis==='prestasi'?'#166534':'#b91c1c'}}>
                                                {p.jenis==='prestasi'?'🏆 ':'⚠️ '}{p.poin} Poin
                                            </div>
                                            <div style={{color:'#475569'}}>{p.keterangan}</div>
                                            <div style={{fontSize:'10px', color:'#94a3b8'}}>{formatTanggal(p.tanggal)}</div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                        <div>
                            <h4 style={{ margin: '0 0 10px', fontSize: '14px', color: '#64748b' }}>🏠 Biodata Lengkap</h4>
                            <div style={{ background: '#f8fafc', padding: '15px', borderRadius: '8px', border: '1px solid #e2e8f0', fontSize: '13px', lineHeight: '1.8', color:'#334155' }}>
                                <div><b>🚻 Gender:</b> {selectedSiswa.jenis_kelamin === 'L' ? 'Laki-laki' : 'Perempuan'}</div>
                                <div><b>📍 Tempat Lahir:</b> {selectedSiswa.tempat_lahir || '-'}</div>
                                <div><b>🕌 Agama:</b> {selectedSiswa.agama || '-'}</div>
                                <div style={{borderTop:'1px dashed #cbd5e1', margin:'8px 0'}}></div>
                                <div><b>📞 HP Ortu:</b> {selectedSiswa.no_hp_ortu || '-'}</div>
                                <div><b>🏠 Alamat:</b><br/>{selectedSiswa.alamat || '-'}</div>
                            </div>
                        </div>
                    </div>

                    <div style={{ marginTop: '25px', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                        <button onClick={() => navigate(`/cetak-kartu/${selectedSiswa.id}`)} style={{ padding: '10px 20px', background: '#3b82f6', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}>🪪 Cetak Kartu</button>
                        <Link to={`/siswa/edit/${selectedSiswa.id}`}>
                            <button style={{ padding: '10px 20px', background: '#f59e0b', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}>✏️ Edit Biodata</button>
                        </Link>
                        <button onClick={closeModal} style={{ padding: '10px 20px', background: '#e2e8f0', color: '#334155', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}>Tutup</button>
                    </div>
                </div>
            </div>
        </div>
      )}
    </div>
  );
};

export default SiswaList;